import React from 'react';
import { motion } from 'framer-motion';
import { Target, Lightbulb, FileText } from 'lucide-react';
export function MissionSection() {
  return <section id="mission" className="py-20 bg-earia-bg-alt border-y border-earia-border" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-3xl md:text-4xl font-bold text-earia-text-heading mb-4" data-id="element-249">
            Nuestro Compromiso Contigo
          </h2>
          <p className="text-earia-text-body max-w-2xl mx-auto text-lg" data-id="element-250">
            Más que un servicio de importación, soy tu aliado estratégico para
            que compres con seguridad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-251">
          {/* Mission */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-earia-card border border-earia-border rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-252">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-253">
              <Target className="w-24 h-24 text-earia-accent" data-id="element-254" />
            </div>

            <div className="relative z-10" data-id="element-255">
              <div className="w-12 h-12 bg-earia-accent/10 rounded-lg flex items-center justify-center mb-6" data-id="element-256">
                <Target className="w-6 h-6 text-earia-accent" data-id="element-257" />
              </div>

              <h3 className="text-2xl font-bold text-earia-text-heading mb-4" data-id="element-258">
                Misión
              </h3>
              <p className="text-earia-text-body leading-relaxed" data-id="element-259">
                Transformar la compra de vehículos en decisiones informadas,
                protegiendo el capital de nuestros clientes y ayudándolos a
                maximizar el valor de su inversión.
              </p>
            </div>
          </motion.div>

          {/* Vision */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-earia-card border border-earia-border rounded-xl p-8 shadow-sm hover:shadow-md transition-shadow relative overflow-hidden group" data-id="element-260">
            <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-261">
              <Lightbulb className="w-24 h-24 text-earia-accent" data-id="element-262" />
            </div>

            <div className="relative z-10" data-id="element-263">
              <div className="w-12 h-12 bg-earia-accent/10 rounded-lg flex items-center justify-center mb-6" data-id="element-264">
                <Lightbulb className="w-6 h-6 text-earia-accent" data-id="element-265" />
              </div>

              <h3 className="text-2xl font-bold text-earia-text-heading mb-4" data-id="element-266">
                Visión
              </h3>
              <p className="text-earia-text-body leading-relaxed" data-id="element-267">
                Lograr que la compra de un vehículo deje de ser un gasto
                impulsivo y se convierta en una decisión financiera inteligente
                que fortalezca el patrimonio de cada uno de nuestros clientes.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Términos y Condiciones */}
        <div className="mt-12 text-center" data-id="element-268">
          <a href="https://1drv.ms/b/c/ce9749865f801225/IQAyug5I0317RpWOi9VXPuWQAQ_nPkLh6HQpjRuV5GZ9UQw?e=5dxgcl" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm text-earia-text-body hover:text-earia-accent transition-colors" data-id="element-269">
            <FileText className="w-4 h-4" data-id="element-270" />
            <span data-id="element-271">Términos y Condiciones</span>
          </a>
        </div>
      </div>
    </section>;
}